/**
 * cards.js Setup Module
 *
 * This module initializes jQuery and cards.js globals required by the library.
 * Import this module for side effects before using cards.js.
 */

// Import jQuery and expose globally (cards.js expects window.$ and window.jQuery)
import $ from 'jquery';
window.$ = window.jQuery = $;

// Import cards.js - it exports the 'cards' object and defines STANDARD, EUCHRE, PINOCHLE
import cards from '../../cards-js/cards.js';
window.cards = cards;

// Re-export deck type constants (defined in cards.js)
export const STANDARD = 0;
export const EUCHRE = 1;
export const PINOCHLE = 2;

export { cards, $ };
